import { createUUID } from "../../utils/utils";

export interface IInputToolTipButton {
    containerViewId : string,
    htmlElement: HTMLElement,
    toolTip?: string,
    delayShow?: number

}

export class ToolTipButton {
    private _input: IInputToolTipButton
    private tooltip: HTMLDivElement | null = null;
    private currentTooltipTarget: HTMLElement | null = null; // Phần tử hiện đang hiển thị tooltip
    private timeoutId: number | null = null; // ID của timeout
    private IdGenneralTooltip = createUUID()
    constructor(input: IInputToolTipButton) {
        this._input = input

        this._createToolTip()
    }

    private _createToolTip = () => {
        const btn = this._input.htmlElement
        btn.setAttribute('data-tooltip', this._input.toolTip ?? "")
        // Gắn sự kiện để hiển thị và ẩn tooltip
        btn.addEventListener('mouseenter', (event) => this._handleMouseEnter(event, this._input.delayShow ?? 1000));
        btn.addEventListener('mouseleave', this._handleMouseLeave);

    }


    // Hàm xử lý khi di chuột vào phần tử có `data-tooltip`
    private _handleMouseEnter = (event: MouseEvent, delay: number ) => {
        let target = event.target as HTMLElement;

        // Duyệt tìm thẻ cha nếu thẻ con không chứa `data-tooltip`
        while (target && !target.hasAttribute('data-tooltip')) {
            target = target.parentElement as HTMLElement;
        }

        // Kiểm tra nếu tìm thấy thẻ cha có `data-tooltip` và nó không phải là phần tử hiện tại
        if (target && target !== this.currentTooltipTarget) {
            this.currentTooltipTarget = target;

            if (this.tooltip) {
                this.hideTooltip();
            }
            // Thêm độ trễ 1 giây trước khi hiển thị tooltip
            if (this.timeoutId) {
                clearTimeout(this.timeoutId); // Hủy timeout cũ nếu tồn tại
            }

            // Thêm độ trễ 1 giây trước khi hiển thị tooltip
            this.timeoutId = window.setTimeout(() => {
                this.showTooltip(target);
            }, delay); // Độ trễ 1000ms
        }
    }

    // Hàm xóa tooltip khỏi DOM
    hideTooltip = () => {
        // Tìm tất cả các phần tử có id là 'dynamic-tooltip'
        const tooltips = document.querySelectorAll(`#dynamic-tooltip-${this.IdGenneralTooltip}`);

        // Xóa từng tooltip nếu tồn tại trong DOM
        tooltips.forEach((tooltip) => {
            tooltip.parentNode?.removeChild(tooltip);
        });

        // Đặt lại giá trị của tooltip và các biến liên quan
        this.tooltip = null;
        this.currentTooltipTarget = null; // Xóa tham chiếu đến phần tử hiện tại

        if (this.timeoutId) {
            clearTimeout(this.timeoutId); // Hủy thời gian chờ nếu có
            this.timeoutId = null;
        }
    }


    // Hàm tạo tooltip với nội dung và vị trí
    showTooltip = (target: HTMLElement) => {
        const tooltipText = target.getAttribute('data-tooltip');

        if (!tooltipText) return;
        const containerId = document.querySelector(`#${this._input.containerViewId}`) as HTMLElement
        const toolBar = containerId.querySelector(`.custom-toolbar-dpu`) as HTMLElement
        // Tạo tooltip mới
        this.tooltip = document.createElement('div');
        this.tooltip.className = 'dynamic-tooltip dynamic-tooltip-arrow-right';
        this.tooltip.id = `dynamic-tooltip-${this.IdGenneralTooltip}`;
        this.tooltip.innerText = tooltipText;

        // Thêm tooltip vào `body`
        containerId!.appendChild(this.tooltip);
        const topOffset = toolBar.offsetTop
        // Lấy vị trí và kích thước của phần tử mục tiêu
        const rect = target.getBoundingClientRect();
        const tooltipWidth = this.tooltip.offsetWidth;


        if (containerId.offsetHeight >= 400) {
            // Đặt tooltip bên trái của phần tử với khoảng cách 5px và căn giữa theo chiều dọc
            this.tooltip.style.left = `${rect.left - tooltipWidth - 10}px`;
            this.tooltip.style.top = `${topOffset + target.offsetTop + rect.height / 2 - this.tooltip.offsetHeight / 2}px`;
        } else if (containerId.offsetHeight < 400) {
            this.tooltip.classList.remove('dynamic-tooltip-arrow-right')
            this.tooltip.classList.add('tooltip-arrow-bottom')
            // Đặt tooltip bên trái của phần tử với khoảng cách 5px và căn giữa theo chiều dọc
            this.tooltip.style.left = `${rect.left + rect.width / 2 - this.tooltip.offsetWidth / 2}px`;
            this.tooltip.style.top = `${topOffset + target.offsetTop - rect.height - 10}px`;
        }


    }

    // Hàm xử lý khi di chuột ra khỏi phần tử có `data-tooltip`
    private _handleMouseLeave = (event: any) => {
        const target = event.target;

        if (target && target.hasAttribute('data-tooltip') || this.tooltip) {
            if (this.timeoutId) {
                clearTimeout(this.timeoutId); // Hủy timeout nếu rời chuột trước khi tooltip hiển thị
                this.timeoutId = null;
            }
            this.hideTooltip(); // Gọi hàm để xóa tooltip ngay lập tức khi rời chuột
        }
    };


}